const sector = "/sector";
const engagement = "/engagement";
const products = "/products";
const projects = "/projects";
const buildings = "/buildings";
const organization = "/organization";
const sustainability = "/sustainability";
const collaborate = "/collaborate";
const compliance = "/compliance";
const notification = "/notification";
const digital_passport = "/digital_passport";
const usage = "/usage";
const library = "/library";
const profile = "/profile";
const admin = "/admin";
const support = "/support";
const setting = "/setting";
const logout = "/logout";
const partnership = "/partnership";
const supply_chain = "/supply_chain";
const structure = "/structure";
const corporate = "/corporate";
const root = window.location.origin;
const home = "/home";
const login = "/login";
const register = "/register";
const terms_and_conditions = "/terms-and-conditions";
const supplier_directory = "/supplier_directory";
const client_directory = "/client_directory";
const b2b_directory = "/b2b_directory";
const routing = {
  root,
  home,
  login,
  register,
  terms_and_conditions,
  sector: {
    root: sector,
    label: "Sector",
    dashboard: sector + "/dashboard",
    products: {
      root: sector + products,
      label: "Products",
      dashboard: sector + products + "/dashboard",
      workspace: sector + products + "/workspace",
      reuse_workspace: sector + products + "/reuse_workspace",
      comparison: sector + products + "/comparison",
      circularity: sector + products + "/circularity",
      supplier_portal: sector + products + "/supplier_portal",
      digital_passport: sector + products + "/digital_passport",
      pre_built_template: sector + products + "/pre_built_template",
      epd_dpp_library: sector + products + "/epd_dpp_library",
      archive: sector + products + "/archive",
      collaborate: sector + products + "/collaborate",
      library: sector + products + "/library",
    },
    projects: {
      root: sector + projects,
      label: "Projects",
      dashboard: sector + projects + "/dashboard",
      workspace: sector + projects + "/workspace",
      comparison: sector + projects + "/comparison",
      circularity: sector + projects + "/circularity",
      supplier_portal: sector + projects + "/supplier_portal",
      digital_passport: sector + projects + "/digital_passport",
      pre_built_template: sector + projects + "/pre_built_template",
      archive: sector + projects + "/archive",
      library: sector + projects + "/library",
    },
    buildings: {
      root: sector + buildings,
      label: "Buildings",
      dashboard: sector + buildings + "/dashboard",
      workspace: sector + buildings + "/workspace",
      leed: sector + buildings + "/leed",
      net_zero: sector + buildings + "/net-zero",
      comparison: sector + buildings + "/comparison",
      circularity: sector + buildings + "/circularity",
      digital_passport: sector + buildings + "/digital_passport",
      pre_built_template: sector + buildings + "/pre_built_template",
      archive: sector + buildings + "/archive",
      library: sector + buildings + "/library",
    },
    compliance: {
      root: sector + compliance,
      label: "Compliance",
      sbti: sector + compliance + "/sbti",
      leed: sector + compliance + "/leed",
    },
  },

  organization: {
    root: organization,
    label: "Organization",
    dashboard: organization + "/dashboard",
    supply_chain: {
      root: organization + supply_chain,
      label: "Supply Chain",
      dashboard: organization + supply_chain + "/dashboard",
      comparison: organization + supply_chain + "/comparison",
      workspace: organization + supply_chain + "/workspace",
    },
    structure: {
      root: organization + structure,
      label: "Structure",
      dashboard: organization + structure + "/dashboard",
      comparison: organization + structure + "/comparison",
      workspace: organization + structure + "/workspace",
    },
    corporate: {
      root: organization + corporate,
      label: "Corporate",
      dashboard: organization + corporate + "/dashboard",
      comparison: organization + corporate + "/comparison",
      workspace: organization + corporate + "/workspace",
    },
    sustainability: {
      root: organization + sustainability,
      label: "Sustainability",
      net_zero: organization + sustainability + "/net-zero",
    },
    compliance: {
      root: organization + compliance,
      label: "Compliance",
      sbti: organization + compliance + "/sbti",
      cdp: organization + compliance + "/cdp",
      eco_vadis: organization + compliance + "/eco_vadis",
    },
  },
  engagement: {
    root: engagement,
    label: "Engagement",
    dashboard: engagement + "/dashboard",
    collaborate: {
      root: engagement + collaborate,
      label: "Collaborate",
      dashboard: engagement + collaborate + "/dashboard",
      digital_data_sharing: engagement + collaborate + "/digital_data_sharing",
      shared_data_history: engagement + collaborate + "/shared_data_history",
      partnership: engagement + collaborate + "/partnership",
      history: engagement + collaborate + "/history",
      my_space: engagement + collaborate + "/my_space",
      internal: engagement + collaborate + "/internal",
      external: engagement + collaborate + "/external",
    },
    supplier_directory: {
      root: engagement + supplier_directory,
      label: "Supplier Directory",
      dashboard: engagement + supplier_directory + "/dashboard",
      submit_data: engagement + supplier_directory + "/submit_data",
      my_submissions: engagement + supplier_directory + "/my_submissions",
      comparison: engagement + supplier_directory + "/comparison",
      reports: engagement + supplier_directory + "/reports",
    },
    client_directory: {
      root: engagement + client_directory,
      label: "Client Directory",
      dashboard: engagement + client_directory + "/dashboard",
      submit_data: engagement + client_directory + "/submit_data",
      my_submissions: engagement + client_directory + "/my_submissions",
      comparison: engagement + client_directory + "/comparison",
      reports: engagement + client_directory + "/reports",
      pending_responses: engagement + client_directory + "/pending_responses",
    },
    b2b_directory: {
      root: engagement + b2b_directory,
      label: "B2B Directory",
      dashboard: engagement + b2b_directory + "/dashboard",
    },
  },
  notification: {
    root: notification,
    label: "Notification",
    dashboard: notification + "/dashboard",
  },
  admin: { root: admin, label: "Admin", dashboard: admin + "/dashboard" },
  digital_passport: {
    root: digital_passport,
    label: "Digital Passport",
    view_published: digital_passport + "/view_published",
    view_pending: digital_passport + "/view_pending",
    edit_pending: digital_passport + "/edit_pending",
    dashboard: digital_passport + "/dashboard",
    history: digital_passport + "/history",
    stats: digital_passport + "/stats",
  },
  partnership: {
    root: partnership,
    label: "Partnership",
    dashboard: partnership + "/dashboard",
  },
  usage: {
    root: usage,
    label: "Usage",
    dashboard: usage + "/dashboard",
  },
  library: {
    root: library,
    label: "Library",
    dashboard: library + "/dashboard",
    archive: library + "/archive",
    prebuilt_template: library + "/prebuilt_template",
    epd: library + "/epd",
  },
  profile: {
    root: profile,
    label: "Profile",
    dashboard: profile + "/dashboard",
    account_settings: profile + "/account_settings",
  },
  support: {
    root: support,
    label: "Support",
    dashboard: support + "/dashboard",
  },
  setting: {
    root: setting,
    label: "Setting",
    dashboard: setting + "/dashboard",
  },
  logout: {
    root: logout,
    label: "Logout",
  },
};

export default routing;
